<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { taxFeeSimulationHistoryLabel } from '../utils/imovelShowFormatters';

defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  successMessage: {
    type: String,
    default: '',
  },
  errorMessage: {
    type: String,
    default: '',
  },
  rows: {
    type: Array,
    default: () => [],
  },
  totalRows: {
    type: Array,
    default: () => [],
  },
  history: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['calculate']);

const taxFeeForm = defineModel('taxFeeForm', {
  type: Object,
  required: true,
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Simulação de taxas e custos" density="cozy">
    <p class="text-[13px] leading-relaxed text-lais-text-body">
      Calcule ITBI, escritura, registro, vistoria, corretagem e custos
      financiados para revisar o custo total antes da publicação.
    </p>

    <div class="mt-4 grid gap-3 sm:grid-cols-2">
      <label class="grid gap-1 text-[12px] font-semibold text-lais-text">
        Forma de pagamento
        <select
          v-model="taxFeeForm.paymentKind"
          class="h-10 rounded-lais-sm border border-lais-border bg-white px-3 text-[13px] font-normal text-lais-text focus:border-lais-primary focus:outline-none"
        >
          <option value="a_vista">À vista</option>
          <option value="financiamento">Financiamento</option>
          <option value="financiamento_fgts">Financiamento + FGTS</option>
        </select>
      </label>
      <label class="grid gap-1 text-[12px] font-semibold text-lais-text">
        Valor financiado
        <input
          v-model="taxFeeForm.financedValue"
          type="number"
          min="0"
          class="h-10 rounded-lais-sm border border-lais-border bg-white px-3 text-[13px] font-normal text-lais-text focus:border-lais-primary focus:outline-none"
          placeholder="500000"
        />
      </label>
      <label class="grid gap-1 text-[12px] font-semibold text-lais-text">
        Prazo
        <input
          v-model.number="taxFeeForm.termMonths"
          type="number"
          min="1"
          max="420"
          class="h-10 rounded-lais-sm border border-lais-border bg-white px-3 text-[13px] font-normal text-lais-text focus:border-lais-primary focus:outline-none"
        />
      </label>
      <div class="grid gap-2 text-[12px] font-semibold text-lais-text">
        <label class="inline-flex items-center gap-2">
          <input
            v-model="taxFeeForm.hasSfh"
            type="checkbox"
            class="size-4 rounded border-lais-border text-lais-primary focus:ring-lais-primary"
          />
          Usa SFH
        </label>
        <label class="inline-flex items-center gap-2">
          <input
            v-model="taxFeeForm.firstPurchase"
            type="checkbox"
            class="size-4 rounded border-lais-border text-lais-primary focus:ring-lais-primary"
          />
          Primeira compra
        </label>
      </div>
    </div>

    <LaisPrimaryButton
      class="mt-4 w-full"
      variant="primary"
      size="sm"
      icon="i-lucide-calculator"
      :is-loading="loading"
      :disabled="loading"
      @click="emit('calculate')"
    >
      Calcular custos
    </LaisPrimaryButton>

    <p
      v-if="successMessage"
      class="mt-3 rounded-lais-sm border border-emerald-200 bg-emerald-50 px-3 py-2 text-[12px] font-semibold text-emerald-800"
    >
      {{ successMessage }}
    </p>
    <p
      v-if="errorMessage"
      class="mt-3 rounded-lais-sm border border-red-200 bg-red-50 px-3 py-2 text-[12px] leading-relaxed text-red-700"
    >
      {{ errorMessage }}
    </p>

    <div v-if="rows.length || totalRows.length" class="mt-4 grid gap-3">
      <dl class="grid gap-2 text-[12px]">
        <div
          v-for="row in rows"
          :key="`tax-fee-simulation-${row.key}`"
          class="flex items-center justify-between gap-3 rounded-lais-sm bg-lais-bg-soft px-3 py-2"
        >
          <dt class="font-semibold text-lais-text">{{ row.label }}</dt>
          <dd class="font-semibold text-lais-text-body">
            {{ row.value }}
          </dd>
        </div>
        <div
          v-for="row in totalRows"
          :key="`tax-fee-total-${row.key}`"
          class="flex items-center justify-between gap-3 rounded-lais-sm border border-lais-border-soft bg-white px-3 py-2"
        >
          <dt class="font-semibold text-lais-text">{{ row.label }}</dt>
          <dd class="font-semibold text-lais-text-body">
            {{ row.value }}
          </dd>
        </div>
      </dl>
    </div>

    <div
      v-if="history.length"
      class="mt-4 border-t border-lais-border-soft pt-3"
    >
      <p class="text-[12px] font-semibold text-lais-text">
        Histórico de simulações
      </p>
      <ul class="mt-2 grid gap-2 text-[12px] text-lais-text-body">
        <li
          v-for="entry in history.slice(0, 5)"
          :key="entry.calculated_at || entry.calculatedAt"
          class="rounded-lais-sm bg-lais-bg-soft px-3 py-2"
        >
          {{ taxFeeSimulationHistoryLabel(entry) }}
        </li>
      </ul>
    </div>
  </LaisCard>
</template>
